

  import { createApiClient } from 'Network/ApiClient';
  
  export const MedicalCodesAxiosInstance = createApiClient('icdmedical/');


